module.exports = __webpack_public_path__ + "media/images/flags/ug-ae71af57a505f9d84d53352a81382d36.svg";